import { MobiDocument } from './MobiDocument';
import { AdresseListeDocument } from './AdresseListeDocument';
import { Ville } from './Ville';
import { LienIndParDocument } from './LienIndParDocument';

export class Parent extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private nom: string;
    private prenom: string;
    private portableperso: string;
    private portablepro: string;
    private telprofessionnel: string;
    private civilite_id: number;
    private famille_id: number;
    private adresseliste_id: number;
    private email: string;
    private telephone: string;

    //Attributs for Vuejs
    private lien: string;
    private isAutoriser: boolean;
    private ville: string;


    public constructor(parent: any) {
        super()
        this._id = parent._id;
        this._rev = parent._rev;
        this.id = parent.id;
        this.nom = parent.nom;
        this.prenom = parent.prenom;
        this.portableperso = parent.portableperso;
        this.portablepro = parent.portablepro;
        this.telprofessionnel = parent.telprofessionnel;
        this.civilite_id = parent.civilite_id;
        this.famille_id = parent.famille_id;
        this.adresseliste_id = parent.adresseliste_id;
        this.email = parent.email;
        this.telephone = parent.telephone;
        this.lien = "Aucune information";
        this.isAutoriser = false;
        this.ville = "";
    }
    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getNom(): string {
        return this.nom;
    }

    public setNom(nom: string): void {
        this.nom = nom;
    }

    public getPrenom(): string {
        return this.prenom;
    }

    public setPrenom(prenom: string): void {
        this.prenom = prenom;
    }

    public getPortableperso(): string {
        return this.portableperso;
    }

    public setPortableperso(portableperso: string): void {
        this.portableperso = portableperso;
    }

    public getPortablepro(): string {
        return this.portablepro;
    }

    public setPortablepro(portablepro: string): void {
        this.portablepro = portablepro;
    }

    public getTelprofessionnel(): string {
        return this.telprofessionnel;
    }

    public setTelprofessionnel(telprofessionnel: string): void {
        this.telprofessionnel = telprofessionnel;
    }

    public getCivilite_id(): number {
        return this.civilite_id;
    }

    public setCivilite_id(civilite_id: number): void {
        this.civilite_id = civilite_id;
    }

    public getFamille_id(): number {
        return this.famille_id;
    }

    public setFamille_id(famille_id: number): void {
        this.famille_id = famille_id;
    }

    public getAdresseliste_id(): number {
        return this.adresseliste_id;
    }

    public setAdresseliste_id(adresseliste_id: number): void {
        this.adresseliste_id = adresseliste_id;
    }

    public getEmail(): string {
        return this.email;
    }

    public setEmail(email: string): void {
        this.email = email;
    }

    public getTelephone(): string {
        return this.telephone;
    }

    public setTelephone(telephone: string): void {
        this.telephone = telephone;
    }

    public getLien(): string {
        return this.lien;
    }

    public setLien(lien: string): void {
        this.lien = lien;
    }

    public isIsAutoriser(): boolean {
        return this.isAutoriser;
    }

    public setIsAutoriser(isAutoriser: boolean): void {
        this.isAutoriser = isAutoriser;
    }

    public getVille(): string {
        return this.ville;
    }

    public setVille(ville: string): void {
        this.ville = ville;
    }

    public getAdresse(): void {
        let adresseListe: AdresseListeDocument = this.memdb.findOne({
            doctype: "AdresseListeDocument",
            fkey: "id",
            fvalue: this.adresseliste_id
        });
        let ville: Ville = adresseListe.getVille();
        this.setVille(ville.getVilleintitule() + " " + ville.getCodepostal());
    }

    public getLienParentIndividu(individu_id: number): void {
        let listLienParentInd: Array<LienIndParDocument> = this.memdb.findAll({
            doctype: "LienIndParDocument",
        });
        let lienParentInd = listLienParentInd.find((lienParInd: LienIndParDocument) =>
            lienParInd.getIndividu_id() === individu_id &&
            lienParInd.getParent_id() === this.id
        );

        if(typeof lienParentInd !== 'undefined'){
            this.setIsAutoriser(lienParentInd.isAutorisation());
            this.setLien(lienParentInd.getLabelLien().getLien());
        }

    }

}